export default __webpack_public_path__ + "static/cashflow6-d21a30816b39b80a00b95d78cf42d2d9.jpg";